import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TenantResponseDto {
  id: number;
  name: string;
  subdomain: string;
  logoBase64: string | null;
  createdAt: string;
  isActive: boolean;
}

export interface ApiResponse<T> {
  isSuccess: boolean;
  message: string;
  data: T | null;
}

@Injectable({
  providedIn: 'root',
})
export class TenantsService {
  private httpClient = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}Tenants`;

  getAllTenants(): Observable<ApiResponse<TenantResponseDto[]>> {
    return this.httpClient.get<ApiResponse<TenantResponseDto[]>>(this.apiUrl);
  }

  getTenantById(id: number): Observable<ApiResponse<TenantResponseDto>> {
    return this.httpClient.get<ApiResponse<TenantResponseDto>>(`${this.apiUrl}/${id}`);
  }

  getSelectedTenant(): TenantResponseDto | null {
    const tenantJson = localStorage.getItem('selected_tenant');
    return tenantJson ? JSON.parse(tenantJson) : null;
  }

  setSelectedTenant(tenant: TenantResponseDto): void {
    localStorage.setItem('selected_tenant', JSON.stringify(tenant));
  }

  clearSelectedTenant(): void {
    localStorage.removeItem('selected_tenant');
  }
}
